/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentTsPayPlanCard from './index/current-tspay-plan-card';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';

/**
 * Style dependencies
 */
import './styles.scss';

const TsPay = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage TS Pay Plan - Tower Systems' />
            <Topbar title='TS Pay Plan' subTitle='Manage your TS Pay plan' selected='tspay'>

            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current TS Pay plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentTsPayPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(TsPay);
